
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   库存统计
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-7">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                 <div class="col-lg-5">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                          开始时间:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                        <date5 @changeDate="changeDate1($event)"/>
                                  </div> 
                                  </div>   
                               </div>
                               <div class="col-lg-5">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                          结束时间:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                       <date5 class="picker2"  @changeDate="changeDate2($event)"/>
                                  </div> 
                                  </div>   
                               </div>
                             
                                 </div>
                                   
                             </div>
                               
                          </div>
                       </div>
                        <div class="col-lg-5">
                          <div class="row ml-lg-3">            
                                 <button class="bg-primary button_zi heit" @click="getClerkStoreGoodsQuery()">查询</button>
                               
                      </div>
                  </div>
                </div>    

            <table v-if="showPage" class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>日期</th>
                        <!-- <th>毛利</th> -->
                        <th>成本</th>
                        <th>记录数</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.backUpDay}}</td>
                              <!-- <td class="jz_middle">{{item.profit}}</td> -->
                              <td class="jz_middle">{{item.cost}}</td>
                              <td class="jz_middle">{{item.counts}}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                   

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import Loading from '../../components/Loading.vue'
import date5 from '../../components/Date/Date5.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          //supplierNum:"",
         DateMoreThan: '',
          DateLessThan: '' ,
            DateLessThan1: '',
          DateMoreThan1: '',// 今天+1
        },//搜索内容
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:true,
        details:[],
        totalLimitMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
        Loading,
        date5,
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        }
},

methods: {

       // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
               getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
  
     //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
         this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
        //   console.log(time)
          this.searchForm.DateMoreThan1=date;
      },   

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
      
    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {

         //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();
    //    console.log(seTime2)
        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{

          if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){

          // this.isLoading=true;
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'StoreGoodsInfoList',
          obj: JSON.stringify({
             StartDate:that.searchForm.DateLessThan,
             EndDate:that.searchForm.DateMoreThan,
          }) 
        })
        // console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.rows
                if(that.tableData.length>0)
                {
                    that.showPage=true;
                }
                else{
                    that.showPage =false;
                }
             
           }

           }
          else{
            alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          }

        }
         
      },

  
    },
     mounted(){
    },
     created () {
      this.searchForm.DateMoreThan=this.getDay1(0)
      this.searchForm.DateLessThan=this.getDay1(-1)
      this.searchForm.DateLessThan1=this.getDay(-2)
      this.searchForm.DateMoreThan1=this.getDay(-1)
        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
</style>


// WEBPACK FOOTER //
// src/pages/manager/InventoryStatistics.vue